/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Custom_Name_LabelInputs */



/**
* | output |
* | --- |
* | "Custom Name" |
*
* @param {Embed_Captions_Custom_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_custom_name_label = /** @type {((inputs?: Embed_Captions_Custom_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Custom_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom personnalise")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerdefinierter Name")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome personalizzato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пользовательское имя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre personalizado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自定义名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カスタム名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रचलित नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome personalizado")
	return /** @type {LocalizedString} */ ("Custom Name")
});